import { getFiles } from "../ManageFiles/fileUtils";

function formatDate(yyyymmdd) {
    if (!yyyymmdd || yyyymmdd.length !== 8) return yyyymmdd;
    const year = yyyymmdd.substring(0, 4);
    const month = yyyymmdd.substring(4, 6);
    const day = yyyymmdd.substring(6, 8);
    return `${day}/${month}/${year}`;
}

export async function fetchFiles(IDD, FolderName) {
    try {
        const data = await getFiles(IDD, FolderName);
        console.log(data);
        if (data && data.output && Array.isArray(data.output)) {
            return data.output
                .filter((item) => item.filename && item.timestamp_date)
                .map((item) => ({
                    filename: item.filename,
                    date: formatDate(item.timestamp_date),
                }));
        }
        return [];
    } catch (error) {
        console.error("Errore nel recupero dei file:", error);
        throw error;
    }
}
